import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { CombinedImage } from '@ynap/image';
import { Features } from '@ynap/feature-selector';
import CollapsableContent from './CollapsableContent';
import LegacySizeGuide from './LegacySizeGuide';

const bem = new BEMHelper('ProductInformationWithSizeAndFit');

const ProductInformationWithSizeAndFit = (props) => {
    const { name, designerName, sizeAndFitInformation, image, messages: { collapsableContent } = {} } = props;

    return (
        <div className={bem('container')}>
            <div className={bem('imageContainer')}>
                <CombinedImage
                    key={image.id}
                    className={bem('thumbnailImage', image.modifier)}
                    src={image.url}
                    alt={image.alt}
                    primarySrcset={image.srcSet}
                    displaySrc={true}
                    yOffset={'100%'}
                />
            </div>
            <div className={bem('productInformationContainer')}>
                {designerName && <div className={bem('designerName')}>{designerName}</div>}
                {name && <p className={bem('name')}>{name}</p>}
                {sizeAndFitInformation && (
                    <>
                        <Features featuresRequired={['collapseSizeAndFit']}>
                            <CollapsableContent messages={collapsableContent}>
                                <div className={bem('sizeAndFitInformation')}>{sizeAndFitInformation}</div>
                            </CollapsableContent>
                        </Features>
                        <LegacySizeGuide className={bem('legacySizeGuide')} />
                    </>
                )}
            </div>
        </div>
    );
};

ProductInformationWithSizeAndFit.propTypes = {
    name: PropTypes.string.isRequired,
    designerName: PropTypes.string.isRequired,
    sizeAndFitInformation: PropTypes.element,
    image: PropTypes.object,
    messages: PropTypes.object,
};

export default ProductInformationWithSizeAndFit;
